import '../../../../assets/css/screens/serviceprovider/dashboard/workerprofile/WorkerProfile.css';
import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Save, Camera, User } from 'lucide-react';


const SERVICES = [

];

/* ── EditProfileModal ── */
const EditProfileModal = ({ form, errors, loading, onChange, onSave, onClose, avatarRef, ProfileImage, setProfileImage, }) => {
  const handleImageUpload = (e) => {
    const file = e.target.files[0];

    if (file) {
      setProfileImage(URL.createObjectURL(file));
    }
  };

  return (
    <div className="wp-modal-overlay" onClick={onClose}>
      <div className="wp-modal" onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div className="wp-modal__header">
          <h3>Edit Profile</h3>
          <button className="wp-modal__close" onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        <div className="wp-modal__body">

          {/* Avatar */}
          <div className="wp-modal__avatar-wrap">
            <div className="wp-modal__avatar-circle" onClick={() => avatarRef.current.click()}>
              {ProfileImage ? (
                <img
                  src={ProfileImage}
                  alt="avatar"
                  className="wp-modal__avatar-img"
                />
              ) : (
                <User size={34} className="wp-modal__avatar-icon" />
              )}
            </div>
            <input
              ref={avatarRef}
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleImageUpload}
            />
          </div>

          {/* Fields */}
          {[
            { key: 'name', label: 'Full Name', type: 'text' },
            { key: 'phone', label: 'Phone Number', type: 'tel' },
            { key: 'email', label: 'Email', type: 'email' },
  
            { key: 'city', label: 'City', type: 'text' },
            { key: 'location', label: 'Location', type: 'text' },

          ].map(f => (
            <div key={f.key} className="wp-field">
              <label>{f.label}</label>
              <input
                type={f.type}
                value={form[f.key] || ''}
                placeholder={f.placeholder || ''}
                onChange={e => onChange(f.key, e.target.value)}
              />
              {f.key === "name" && errors.fullName && (
                <span className="worker-error">
                  {errors.fullName}
                </span>
              )}

              {f.key === "email" && errors.email && (
                <span className="worker-error">
                  {errors.email}
                </span>
              )}

              {f.key === "phone" && errors.phone && (
                <span className="worker-error">
                  {errors.phone}
                </span>
              )}
            </div>
          ))}





          {/* Bio */}
          <div className="wp-field">
            <label>Bio</label>
            <textarea
              value={form.about || ''}
              rows={3}
              placeholder="About yourself..."
              onChange={e => onChange('about', e.target.value)}
            />
          </div>

        </div>

        {/* Footer */}
        <div className="wp-modal__footer">
          <button className="wp-modal__cancel" onClick={onClose}>Cancel</button>
          <button
            className="wp-modal__save"
            onClick={onSave}
            disabled={loading}
          >
            <Save size={15} />
            {loading ? " Saving..." : " Save Changes"}
          </button>
        </div>

      </div>
    </div>
  );
};

export default EditProfileModal;